import { getSettingFaireMarketStyledHomepageOnClickEventName } from "@faire/retailer/settings/getSettingFaireMarketStyledHomepageOnClickEventName";

export const MY_MARKET_LIST_CAROUSEL = "homepage_market_your_market_list";

export const showMarketTreatment = (onClickEventName?: string) => {
  if (!onClickEventName) {
    return false;
  }
  return getSettingFaireMarketStyledHomepageOnClickEventName().includes(
    onClickEventName
  );
};
